import React, { Component } from "react";

import starImg from "../../images/star.svg";

class ContactBody extends Component {
  render() {
    return (
      <div>
        {this.props.data.PrimaryContact && (
          <div className="primary-obj">
            <img alt="" src={starImg} />
            <span>Primary Contact</span>
          </div>
        )}
        <div className="data-line">
          <span>Name: </span>
          <span className="value-data">
            {this.props.data.FirstName} {this.props.data.LastName}
          </span>
        </div>
        <div className="data-line">
          <span>Phone: </span>
          <span className="value-data">
            {this.props.data.Phone}
            {this.props.data.PhoneExt}
          </span>
        </div>
        <div className="data-line">
          <span>Mobile: </span>
          <span className="value-data">{this.props.data.Mobile}</span>
        </div>
        <div className="data-line">
          <span>Email: </span>
          <span className="value-data">{this.props.data.EmailAddress}</span>
        </div>
      </div>
    );
  }
}

export default ContactBody;
